'use client';

import { useCallback, useRef } from 'react';

export function useScrollToSection() {
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);

  const setRef = useCallback(
    (index: number) => (el: HTMLDivElement | null) => {
      sectionRefs.current[index] = el;
    },
    []
  );

  const scrollToSection = useCallback((index: number) => {
    const el = sectionRefs.current[index];
    if (el) {
      // 약간의 딜레이 후 스크롤 (애니메이션 완료 대기)
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, []);

  return { setRef, scrollToSection };
}
